import React from 'react';
import { Formik, Field, Form } from 'formik';
import { Button, Col, Row } from 'react-bootstrap';
import axios from 'axios';
import ChampFormulaire from '../../Common/ChampFormulaire';
import { schemaNousJoindre } from '../../../../../common/src/schemas/nous-joindre.schema';

import { useAlertDialog } from '../../../Utils/dialogContext';

export interface NousJoindreFormData {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    organisationName: string;
    poste: string;
    objet: string;
    message: string;
}

const NousJoindreForm: React.FC = () => {
    const bsAlert = useAlertDialog();
    const handleSubmit = async (
        values: NousJoindreFormData,
        { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void },
    ) => {
        try {
            const response = await axios.post('/api/joindre', values);
            bsAlert('Votre demande a été soumise avec succès ! Une copie vous a été envoyée par courriel.', 'success');
        } catch (error) {
            console.error('Erreur lors de la soumission du formulaire', error);
            alert('Erreur lors de la soumission du formulaire, veuillez réessayer.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Formik
            initialValues={{
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                poste: '',
                message: '',
                objet: '',
                organisationName: '',
            }}
            validationSchema={schemaNousJoindre}
            onSubmit={handleSubmit}
        >
            {({ isSubmitting, errors, touched }) => (
                <Form>
                    <h1>Nous joindre !</h1>
                    <Row>
                        <Col>
                            <ChampFormulaire
                                id="firstName"
                                titre="Prénom"
                                placeholder="Entrez votre prénom."
                                type="text"
                                errorMessage={touched.firstName && errors.firstName ? errors.firstName : ''}
                            />
                        </Col>
                        <Col>
                            <ChampFormulaire
                                id="lastName"
                                titre="Nom"
                                placeholder="Entrez votre nom."
                                type="text"
                                errorMessage={touched.lastName && errors.lastName ? errors.lastName : ''}
                            />
                        </Col>
                    </Row>
                    <ChampFormulaire
                        id="email"
                        titre="Courriel"
                        placeholder="Entrez votre courriel."
                        type="email"
                        errorMessage={touched.email && errors.email ? errors.email : ''}
                    />
                    <ChampFormulaire
                        id="phone"
                        titre="Téléphone"
                        placeholder="Téléphone : 514-114-1111. Si applicable, incluez votre numéro de poste."
                        type="text"
                        errorMessage={touched.phone && errors.phone ? errors.phone : ''}
                    />
                    <ChampFormulaire
                        id="poste"
                        titre="Poste dans l'organisation"
                        placeholder="Par exemple : responsable du service de garde, enseignant, directeur, etc."
                        type="text"
                        errorMessage={touched.poste && errors.poste ? errors.poste : ''}
                    />
                    <ChampFormulaire
                        id="organisationName"
                        titre="Nom de l'organisation"
                        placeholder="Quel est le nom de votre école ou entreprise ?"
                        type="text"
                        errorMessage={
                            touched.organisationName && errors.organisationName ? errors.organisationName : ''
                        }
                    />
                    <ChampFormulaire
                        id="objet"
                        titre="Objet"
                        placeholder="Objet de la demande : Demande de réservation, Demande de rendez-vous..."
                        type="text"
                        errorMessage={touched.objet && errors.objet ? errors.objet : ''}
                    />
                    <ChampFormulaire
                        id="message"
                        titre="Message"
                        placeholder="Entrez votre message"
                        textarea
                        noAutoAjust
                        errorMessage={touched.message && errors.message ? errors.message : ''}
                    />
                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                        Envoyer le formulaire
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default NousJoindreForm;
